import type { ScheduleItem } from '@/types';
import { getMinutesUntilDeparture } from '../../utils/departureHelpers';

interface DepartureTimeProps {
  item: ScheduleItem;
  isWhite?: boolean;
}

export function DepartureTime({ item }: DepartureTimeProps) {
  const minutes = getMinutesUntilDeparture(item.departure_time);

  return (
    <h4>
      <span>{minutes}</span>
      {item.is_real_time && <i className="realtime" />}
      <small>
        min
      </small>
    </h4>
  );
}

interface InactiveDepartureProps {
  isWhite?: boolean;
}

export function InactiveDeparture({ isWhite }: InactiveDepartureProps) {
  return (
    <h4>
      <span className={isWhite ? 'inactive white' : 'inactive'}>&nbsp;</span>
    </h4>
  );
}
